import TextField from '@material-ui/core/TextField';

export default function InputText({ children, ...props }: any) {
  return (
    <TextField variant="outlined" {...props} />
  )
}